import { AlertTriangle } from 'lucide-react';
import { useAuthStore } from '@/stores/auth';
import { useSwitchTenant } from '@/hooks/useSwitchTenant';
import { useIsActingAsSystemAdmin } from '@/hooks/useIsActingAsSystemAdmin';
import { useActiveTenantDisplayName } from '@/hooks/useActiveTenantDisplayName';

/** v1.0 Phase4 (docs/design/v10-phase4-platform-admin-ui.md §3-3、design書Chapter6.3 Design C-2):
 *  システム管理者 (cross_tenant_admin) が自分のテナント以外を操作中であることを常時可視化するバナー。
 *  active_tenant_id !== primary_tenant_id の間のみ表示する。
 *
 *  v1.0 Phase1-5最終監査 MEDIUM対応 (design書R-3残存リスク): 従来は「他テナントを操作中」とだけ
 *  表示しどのテナントかが分からず、誤操作(意図しないテナントで破壊的操作を実行する等)のリスクが
 *  あった。useActiveTenantDisplayName で具体的なテナント名を解決する。 */
export function SystemAdminBanner() {
  const user = useAuthStore((s) => s.user);
  const { switchTenant, switching } = useSwitchTenant();
  const isActing = useIsActingAsSystemAdmin();
  const tenantName = useActiveTenantDisplayName();

  if (!isActing) return null;

  const returnHome = () => {
    if (user?.primary_tenant_id) void switchTenant(user.primary_tenant_id, '自分のテナント');
  };

  return (
    <div className="flex items-center justify-center gap-2 bg-alert-bg border-b border-alert-border text-alert-text text-[13px] font-semibold px-3 py-1">
      <AlertTriangle size={14} className="shrink-0" aria-hidden />
      <span>
        システム管理者として「{tenantName ?? user?.active_tenant_id ?? '他テナント'}」を操作中
      </span>
      <button
        type="button"
        onClick={returnHome}
        disabled={switching}
        className="ml-2 inline-flex items-center min-h-[44px] sm:min-h-[32px] underline underline-offset-2 hover:no-underline disabled:opacity-50"
      >
        {switching ? '切替中…' : '自分のテナントに戻る'}
      </button>
    </div>
  );
}
